import React, { useEffect, useState } from "react";
import RequestResetPassword from "@/components/RequestResetPassword";
import ResetPassword from "@/components/ResetPassword";

const ResetPasswordPage = () => {
  const [resetToken, setResetToken] = useState("");
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    if (token) {
      setResetToken(token);
      // console.log("Detected reset code:", token);
    }
  }, [location.search]);
  return (
    <div className="flex items-center justify-center w-full h-[100vh]">
      {!resetToken ? <RequestResetPassword /> : <ResetPassword />}
    </div>
  );
};

export default ResetPasswordPage;
